import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	over: {
		id: 'software-deployment-frequency-report.common.trend-lozenge.over',
		defaultMessage: 'over',
		description:
			'The lozenge text indicating the statistics of the selected period is over the the target timespan',
	},
	under: {
		id: 'software-deployment-frequency-report.common.trend-lozenge.under',
		defaultMessage: 'under',
		description:
			'The lozenge text indicating the statistics of the selected period is under the the target timespan',
	},
	equal: {
		id: 'software-deployment-frequency-report.common.trend-lozenge.equal',
		defaultMessage: 'equal',
		description:
			'The lozenge text indicating the statistics of the selected period is equal to the the target timespan',
	},
});
